import { Appearance } from 'common/types/entities/EntityInterface'
import { MarginType } from 'common/types/styleTypes'
import StyleWrapperUi from 'publisher/components/core/StyleWrapperUi'
import { useManagement } from 'publisher/store'
import managementSelectors from 'publisher/store/management/managementSelectors'
import React, { PropsWithChildren } from 'react'
import { CSSObject } from 'styled-components'

export type StyleWrapperProps = {
  id?: string
  margin?: MarginType
  mobileMargin?: Partial<MarginType>
  appearance?: Appearance
  flex?: boolean
  flexColumn?: boolean
  textAlign?: string
  mobileTextAlign?: string
  additionalCss?: CSSObject
  mobileAdditionalCss?: CSSObject
}

const StyleWrapper = (props: PropsWithChildren<StyleWrapperProps>) => {
  const isScreenshotMode = useManagement(managementSelectors.isScreenshotMode)

  return (
    <StyleWrapperUi
      {...props}
      appearance={
        !props.appearance || isScreenshotMode
          ? {
              desktop: true,
              mobile: true,
            }
          : {
              desktop: props.appearance?.desktop || false,
              mobile: props.appearance?.mobile || false,
            }
      }
    />
  )
}

export default StyleWrapper
